import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class IntegrationFormController extends Controller {
  connect () {
    this.adapterSelect = this.element.querySelector('[name*="adapter_type"]')
    this.apiKeyInput = this.element.querySelector('[name*="api_key"]')

    if (this.adapterSelect) {
      this.boundUpdate = this.updatePlaceholder.bind(this)
      this.adapterSelect.addEventListener('change', this.boundUpdate)
    }

    this.updatePlaceholder()
  }

  disconnect () {
    if (this.adapterSelect && this.boundUpdate) {
      this.adapterSelect.removeEventListener('change', this.boundUpdate)
    }
  }

  updatePlaceholder () {
    if (!this.adapterSelect || !this.apiKeyInput) return

    if (this.adapterSelect.value === 'woocommerce') {
      this.apiKeyInput.placeholder = 'consumer_key:consumer_secret'
    } else {
      this.apiKeyInput.placeholder = ''
    }
  }
}

stimulus.register('integration-form', IntegrationFormController)
